<template>
    <InfoCard
        v-if="true"
        :img-src="overduePaymentSvg"
        img-alt=""
        :title="t('vue.past_due_subscription_warning_title')"
        :body-text="t('vue.past_due_subscription_warning_description')"
        :button-label="t('vue.past_due_subscription_update_payment')"
        :button-href="route('billing.subscriptions.index')"
        button-color="yellow"
        :custom-width="200"
        :custom-height="138"
    />
</template>

<script setup lang="ts">
import route from "ziggy-js";
import InfoCard from "@/components/Content/InfoCard.vue";
import { useTranslations } from "@/composables/useTranslations.ts";
import usePastDueWarning from "@/composables/usePastDueWarning.ts";

const { t } = useTranslations();
const { showPastDueWarning } = usePastDueWarning();

const overduePaymentSvg = new URL(
    "/resources/js/assets/images/overdue-payment-subs.svg",
    import.meta.url,
).href;
</script>
